var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"self-introduction"},[_c('h3',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.$translate('INTRODUCTION'))}}),_c('p',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.intro)}})])}
var staticRenderFns = []

export { render, staticRenderFns }